module.exports = __webpack_public_path__ + "static/media/12-RotHeatExchanger - DX cool - Water heat.1e5a2200.png";